import script from "./ProjectInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProjectInfo.vue?vue&type=style&index=0&id=93720a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93720a06"]])

export default __exports__